import Head from "next/head";
import MarkdownDocument from "../components/Cards/MarkdownDocument";
const result = {
  data: {
    htmlContent: {
      html: `<h1>External Transmission of User Information</h1>
      <p>This service may collect information on users that is recorded by such users’ computer, smartphone or other such devices, and transmits such information to others’ telecommunications equipment (web servers, etc.). Specifically, as shown in the table below, cookies, etc. may be used to collect the users’ browsing history, etc. and to analyze the users’ behavior, etc.</p>
      <table>
        <tr>
          <td>Classification</td>
          <td>Access analysis</td>
        </tr>
        <tr>
          <td>Service name</td>
          <td>Google Analytics (GA4)</td>
        </tr>
        <tr>
          <td>Purpose of our use</td>
          <td>Implement Google Analytics, an analytical tool, for analysis and improvement based on customer behavior analysis. </td>
        </tr>
        <tr>
          <td>Destination (of transmission)</td>
          <td>Google LLC</td>
        </tr>
        <tr>
          <td>Information to be sent</td>
          <td>
            <ul>
              <li>Event contents</li>
              <li>User dimension contents</li>
              <li>Number of users</li>
              <li>Session statistics</li>
              <li>Approximate location information</li>
              <li>information of browser and device</li>
              <li>Client ID</li>
              <li>App instance identifier</li>
              <li>Ad identifier, etc.</li>
            </ul>
            <p> For more information, please visit the following web page <br />
              <a href="https://support.google.com/analytics/answer/11593727?hl=en&sjid=7776235210751842965-AP" target="_blank" style="color: blue;">Analytics Help - [GA4] Data Collection</a>
            </p>
          </td>
        </tr>
        <tr>
          <td>Purpose of use of destination</td>
          <td>Google uses the information shared by sites and apps to deliver our services, maintain and improve them, develop new services, measure the effectiveness of advertising, protect against fraud and abuse, and personalize content and ads you see on Google and on our partners’ sites and apps. </td>
        </tr>
   
        <tr>
          <td>Destination privacy policy</td>
          <td>
            <a href="https://policies.google.com/technologies/partner-sites?hl=en" target="_blank" style="color: blue;">https://policies.google.com/technologies/partner-sites?hl=en </a>
          </td>
        </tr>
        <tr>
          <td>Opt out</td>
          <td>
            <a href="https://tools.google.com/dlpage/gaoptout?hl=en" target="_blank" style="color: blue;">https://tools.google.com/dlpage/gaoptout?hl=en</a>
          </td>
        </tr>
        <tr>
          <td>Remarks</td>
          <td>Reference web page <br /> Analytics help - safeguarding your data <br />
            <a href="https://support.google.com/analytics/answer/6004245?hl=en&ref_topic=2919631&sjid=3429061032964600977-AP" target="_blank" style="color: blue;">https://support.google.com/analytics/answer/6004245?hl=en&ref_topic=2919631&sjid=3429061032964600977-AP</a>
          </td>
        </tr>
        </table>
        <table>
        <tr>
          <td>Classification</td>
          <td>Advertisement</td>
        </tr>
        <tr>
          <td>Service name</td>
          <td>Google Ads</td>
        </tr>
        <tr>
          <td>Purpose of our use</td>
          <td>To deliver advertisements</td>
        </tr>
        <tr>
          <td>Destination (of transmission)</td>
          <td>Google LLC</td>
        </tr>
        <tr>
          <td>Information to be sent</td>
          <td> - Conversion ID for Google Ads <br /> - Google Ads conversion label <br /> - Purchase completion event (purchase amount, order ID) <br /> - Completion event for storefront inquiry <br /> - Purchasing user's email address, phone number, zip <br /> etc. </td>
        </tr>
        <tr>
          <td>Purpose of use of destination </td>
          <td>Google uses the information shared by sites and apps to deliver our services, maintain and improve them, develop new services, measure the effectiveness of advertising, protect against fraud and abuse, and personalize content and ads you see on Google and on our partners’ sites and apps. </td>
        </tr>
        <tr>
          <td>Destination privacy policy</td>
          <td>
            <a href="https://support.google.com/adspolicy/answer/54818?hl=en&sjid=3429061032964600977-AP" target="_blank" style="color: blue;">https://support.google.com/adspolicy/answer/54818?hl=en&sjid=3429061032964600977-AP</a>
          </td>
        </tr>
        <tr>
          <td>Opt out</td>
          <td>
            <a href="https://support.google.com/adsense/answer/142293?hl=en&sjid=3429061032964600977-AP" target="_blank" style="color: blue;">https://support.google.com/adsense/answer/142293?hl=en&sjid=3429061032964600977-AP</a>
          </td>
        </tr>
        </table>
        <table>
        <tr>
          <td>Classification</td>
          <td>Advertisement</td>
        </tr>
        <tr>
          <td>Service name</td>
          <td>Google AdWords</td>
        </tr>
        <tr>
          <td>Purpose of our use</td>
          <td>To deliver advertisements</td>
        </tr>
        <tr>
          <td>Destination (of transmission)</td>
          <td>Google LLC</td>
        </tr>
        <tr>
          <td>Information to be sent </td>
          <td> - Conversion ID for Google Ads <br /> - Google Ads Conversion Label <br /> - Purchase completion event (purchase amount, order ID) <br /> - Completion event for storefront inquiry <br /> - Purchasing user's email address, phone number, zip <br /> etc. </td>
        </tr>
        <tr>
          <td>Purpose of use of destination</td>
          <td>Google uses the information shared by sites and apps to deliver our services, maintain and improve them, develop new services, measure the effectiveness of advertising, protect against fraud and abuse, and personalize content and ads you see on Google and on our partners’ sites and apps.</td>
        </tr>
        <tr>
          <td>Destination privacy policy </td>
          <td>
            <a href="https://support.google.com/adspolicy/answer/54818?hl=en&sjid=3429061032964600977-AP" target="_blank" style="color: blue;">https://support.google.com/adspolicy/answer/54818?hl=en&sjid=3429061032964600977-AP</a>
          </td>
        </tr>
        <tr>
          <td>Opt out</td>
          <td>
            <a href="https://support.google.com/adsense/answer/142293?hl=en&sjid=3429061032964600977-AP" target="_blank" style="color: blue;">https://support.google.com/adsense/answer/142293?hl=en&sjid=3429061032964600977-AP</a>
          </td>
        </tr>
        </table>
        <table>
        <tr>
          <td>Classification</td>
          <td>Advertisement</td>
        </tr>
        <tr>
          <td>Service name</td>
          <td>Facebook Pixel</td>
        </tr>
        <tr>
          <td>Purpose of our use </td>
          <td>To deliver advertisements</td>
        </tr>
        <tr>
          <td>Destination (of transmission)</td>
          <td>Meta Platforms, Inc.</td>
        </tr>
        <tr>
          <td>Information to be sent</td>
          <td> - Page browsing history <br /> - Purchase history (including purchase amounts, etc.) <br /> etc. </td>
        </tr>
        <tr>
          <td>Purpose of use of destination </td>
          <td>We may also use information we receive from our partners to display relevant advertising.</td>
        </tr>
        <tr>
          <td>Destination privacy policy</td>
          <td>
            <a href="https://www.facebook.com/privacy/policy/?section_id=2-HowDoWeUse" target="_blank" style="color: blue;">https://www.facebook.com/privacy/policy/?section_id=2-HowDoWeUse</a>
          </td>
        </tr>
        <tr>
          <td>Opt out</td>
          <td>
            <a href="https://www.facebook.com/help/769828729705201/?cms_id=769828729705201" target="_blank" style="color: blue;">https://www.facebook.com/help/769828729705201/?cms_id=769828729705201</a>
          </td>
        </tr>
        </table>
        <table>
        <tr>
          <td>Classification</td>
          <td>Settlement agent</td>
        </tr>
        <tr>
          <td>Service name</td>
          <td>Stripe</td>
        </tr>
        <tr>
          <td>Purpose of our use</td>
          <td>To provide a secure means of payment</td>
        </tr>
        <tr>
          <td>Destination (of transmission) </td>
          <td>Stripe, Inc.</td>
        </tr>
        <tr>
          <td>Information to be sent</td>
          <td>User behavior patterns</td>
        </tr>
        <tr>
          <td>Purpose of use of destination </td>
          <td>Used to detect and prevent fraudulent use in the payment process</td>
        </tr>
        <tr>
          <td>Destination privacy policy</td>
          <td>
            <a href="https://stripe.com/jp/privacy" target="_blank" style="color: blue;">https://stripe.com/jp/privacy</a>
          </td>
        </tr>
        <tr>
          <td>Opt out </td>
          <td>
            <a href="https://stripe.com/jp/privacy" target="_blank" style="color: blue;">https://stripe.com/jp/privacy</a>
          </td>
        </tr>
      </table>
      
      `,
    },
  },
};
export default function ExternalTransmissionRule() {
  return (
    <>
      <Head>
        <title>External Transmission Rule</title>
      </Head>
      <MarkdownDocument result={result} />
    </>
  );
}
